// src/fontawesome.ts
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

library.add(faUser, faSignOutAlt);

// Import this file in your App.tsx
// import './fontawesome';
